import { Loader2 } from "lucide-react";
import { ReactNode } from "react";

type PrimaryActionButtonProps = {
    onClick: () => void;
    label: string;
    disabled?: boolean;
    loading?: boolean;
    leftIcon?: ReactNode;
    rightIcon?: ReactNode;
    variant?: 'filled' | 'outlined';
}
const PrimaryActionButton = ({ onClick, label, disabled, loading, leftIcon, rightIcon, variant = 'filled' }: PrimaryActionButtonProps) => {
    return (
        <div
            className={`w-full flex flex-row items-center justify-between px-5 py-3 rounded-full cursor-pointer ${variant === 'outlined' ? 'border-2 border-burgundy text-burgundy bg-transparent' : 'border-2 border-burgundy text-white bg-burgundy'} ${disabled === true || loading === true ? 'opacity-70' : ''}`}
            onClick={() => {
                if (disabled === true || loading === true) {
                    return;
                }
                onClick();
            }}
        >
            <div className='w-6 flex justify-start'>
                {!loading && leftIcon}
            </div>

            <div className='flex flex-row gap-2 items-center'>
                {loading && <Loader2 className='animate-spin' />}
                <span className='text-center text-base'>{label}</span>
            </div>

            <div className='w-6 flex justify-end'>
                {rightIcon}
            </div>
        </div>
    )
}

export default PrimaryActionButton;